// 十進位字串運算，單價乘數量後，每筆金額四捨五入至小數點第二位。
// 避免打包將 ** 轉成不支援 BigInt 的 Math.pow。
const ten = (scale) => {
  let result = BigInt(1);
  for (let i = 0; i < scale; i += 1) result *= BigInt(10);
  return result;
};

const parseDecimal = (value) => {
  const text = String(value ?? 0).replace(/,/g, '').trim() || '0';
  const match = text.match(/^([+-]?)(\d*)(?:\.(\d*))?(?:e([+-]?\d+))?$/i);
  if (!match || (!match[2] && !match[3])) throw new Error('請輸入有效數字');
  const exponent = Number(match[4] || 0);
  if (Math.abs(exponent) > 30) throw new Error('數字超出可計算範圍');
  let scale = (match[3] || '').length - exponent;
  let number = BigInt((match[2] || '0') + (match[3] || '')) * (match[1] === '-' ? BigInt(-1) : BigInt(1));
  if (scale < 0) { number *= ten(-scale); scale = 0; }
  return { number, scale };
};

const rescale = (number, from, to) => {
  if (from <= to) return number * ten(to - from);
  const divisor = ten(from - to);
  const sign = number < 0 ? BigInt(-1) : BigInt(1);
  const absolute = number * sign;
  return (absolute / divisor + (absolute % divisor * BigInt(2) >= divisor ? BigInt(1) : BigInt(0))) * sign;
};

const decimalText = (number, scale, fixed = false) => {
  const sign = number < 0 ? '-' : '';
  const digits = (number < 0 ? -number : number).toString().padStart(scale + 1, '0');
  if (scale === 0) return sign + digits;
  const result = `${sign}${digits.slice(0, -scale)}.${digits.slice(-scale)}`;
  return fixed ? result : result.replace(/\.?0+$/, '');
};

export const formatPurchasePrice = (value) => {
  const parsed = parseDecimal(value);
  return decimalText(rescale(parsed.number, parsed.scale, 4), 4, true);
};

export const purchaseLineAmount = (price, quantity) => {
  const p = parseDecimal(formatPurchasePrice(price));
  const q = parseDecimal(quantity);
  const number = p.number * q.number;
  const scale = p.scale + q.scale;
  const stored = rescale(number, scale, 2);
  if ((stored < 0 ? -stored : stored) >= ten(18)) {
    throw new Error('採購金額超出可保存範圍，請確認單價及數量');
  }
  return decimalText(stored, 2, true);
};

export const purchaseCurrency = (row) => (row.幣別 ?? row.pric ?? row.Pric ?? '').trim().toUpperCase();

export const formatPurchaseTotals = (rows) => {
  const sums = new Map();
  rows.forEach((row) => {
    const currency = purchaseCurrency(row);
    const amount = parseDecimal(row.amountExact ?? row.金額 ?? 0);
    sums.set(currency, (sums.get(currency) || BigInt(0)) + rescale(amount.number, amount.scale, 12));
  });
  return Array.from(sums.keys()).sort().map((currency) => {
    const scale = currency === 'TWD' ? 0 : 2;
    return `${currency || '未設定幣別'} ${decimalText(rescale(sums.get(currency), 12, scale), scale, true)}`;
  }).join(' / ');
};
